import { ActivatedRoute, Route } from "@angular/router";

import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormContext } from "@form/cer-form-context";
import { CerFormDataNavigation } from "@form/cer-form-navigation.service";
import { CerFormRouteOptions } from "@form/cer-form-route-options";
import { CerFormViewFactoryAdapter } from "@form/cer-form-factory/cer-form-factory-adapter";
import { CerFormViewFactoryComponent } from "@form/cer-form-factory/cer-form-factory-component";
import { CerFormViewSet } from "@form/cer-form-view-set";
import { CerRoute } from "src/cer/cer-route/cer-route";

export class CerFormFactoryViewSet {

  public static async viewSetBuildByNavigation(context: CerFormContext, nav: CerFormDataNavigation, callerData: CerFormRouteOptions = null): Promise<CerFormViewSet> {
    const o = new CerFormRouteOptions(context, callerData);
    if (nav?.route != null) {
      CerFormFactoryViewSet.routeOptionsInitFromRoute(o, nav.route);
    }
    else if (nav?.url.length > 0) {
      o.routeUrl = nav.url;
    }
    o.navigation = nav;
    o.parentView = nav.parentView;
    o.callerData = nav.callerData;
    CerFormFactoryViewSet.routeOptionsInitRouteData(o);
    return await CerFormFactoryViewSet.viewSetBuildByRouteOptions(o);
  }

  public static async viewSetBuildByActivatedRoute(context: CerFormContext, activatedRoute: ActivatedRoute): Promise<CerFormViewSet> {
    const o = new CerFormRouteOptions(context);
    const r = activatedRoute.snapshot;
    o.title = r.title;
    o.routeUrl = CerRoute.urlFromActivatedRoute(activatedRoute);
    o.routeComponentType = r.component;
    o.routeData = r.data;
    o.paramMap = activatedRoute.paramMap;
    o.paramMapSnapshot = activatedRoute.snapshot.paramMap;
    o.queryParamMap = activatedRoute.queryParamMap;
    o.queryParamMapSnapshot = activatedRoute.snapshot.queryParamMap;
    CerFormFactoryViewSet.routeOptionsInitRouteData(o);
    return await CerFormFactoryViewSet.viewSetBuildByRouteOptions(o);
  }

  private static async viewSetBuildByRouteOptions(routeOptions: CerFormRouteOptions): Promise<CerFormViewSet> {
    if (routeOptions.routeAdapterType != null) {
      return await CerFormViewFactoryAdapter.formviewSetFromRouteOptions(routeOptions);
    }
    else {
      return CerFormViewFactoryComponent.formviewSetFromRouteOptions(routeOptions);
    }
  }

  private static routeOptionsInitFromRoute(o: CerFormRouteOptions, r: Route) {
    o.title = <string>r.title;
    o.routeUrl = CerRoute.urlFromRoute(r);
    o.routeComponentType = r.component;
    o.routeData = r.data;
    o.queryParamMap = null;
    CerFormFactoryViewSet.routeOptionsInitRouteData(o);
  }

  private static routeOptionsInitRouteData(o: CerFormRouteOptions) {
    if (o.routeData == null) {
      return;
    }
    o.routeAdapterType = o.routeData['formAdapterType'] ?? o.routeData['formType'];
    const adapterType: typeof CerFormAdapter = o.routeAdapterType;
    if (adapterType instanceof CerFormAdapter) {
      o.routeAdapterType = o.routeData['formAdapterType'];
    }
    o.routeParams = o.routeData['params'];
  }

  public static routeOptionsEqual(o1: CerFormRouteOptions, o2: CerFormRouteOptions): boolean {

    if ((o1 == null && o2 != null) || (o1 != null && o2 == null)) {
      return false;
    }
    if (o1.routeUrl?.length > 0 && o2.routeUrl?.length > 0 && o1.routeUrl != o2.routeUrl) {
      return false;
    }
    if (o1.parentView != o2.parentView) {
      return false;
    }
    if (o1.parentView != o2.parentView) {
      return false;
    }
    if (o1.navigation?.columnNameChild != o2.navigation?.columnNameChild) {
      // Filter different
      return false;
    }
    if (o1.navigation?.callerData != o2.navigation?.callerData) {
      if (JSON.stringify(o1.navigation?.callerData) != JSON.stringify(o2.navigation?.callerData)) {
        return false;
      }
    }
    if (o1.callerData != null && o2.callerData != null) {
      if (JSON.stringify(o1.callerData) != JSON.stringify(o2.callerData)) {
        return false;
      }
    }

    const n1 = o1.navigation;
    const n2 = o2.navigation;
    if (n1 != null && n2 != null) {
      if (n1.filterStatic != n2.filterStatic) {
        return false;
      }
    }
    return true;
  }

}